import { Link } from "react-router-dom";
import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";
import { Compass } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-surface-50 text-ink-900">
      <Header />
      <main data-testid="not-found-page" className="mx-auto flex max-w-2xl flex-col items-center px-6 py-24 text-center lg:px-8 lg:py-32">
        <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-white ring-1 ring-surface-200 text-intel-800">
          <Compass className="h-6 w-6" strokeWidth={1.5} />
        </span>
        <p className="mt-6 font-mono text-xs font-semibold uppercase tracking-widest text-intel-800">
          404
        </p>
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-ink-900 sm:text-4xl">
          الصفحة غير متوفّرة
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-ink-500">
          الرابط الذي حاولت الوصول إليه غير موجود، أو ربّما تمّ نقله. عد إلى الصفحة الرئيسية
          أو تصفَّح الفرص المتاحة.
        </p>
        <div className="mt-8 flex flex-col gap-2 sm:flex-row">
          <Link
            to="/"
            data-testid="not-found-home"
            className="inline-flex items-center justify-center gap-1.5 rounded-md bg-intel-800 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-intel-700"
          >
            العودة إلى الرئيسية
          </Link>
          <Link
            to="/opportunities"
            data-testid="not-found-opportunities"
            className="inline-flex items-center justify-center gap-1.5 rounded-md border border-surface-200 bg-white px-5 py-2.5 text-sm font-medium text-ink-700 transition-colors hover:border-intel-300 hover:text-ink-900"
          >
            استكشاف الفرص
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
